import { jsx as l } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M35.97 27.57a4.277 4.277 0 0 0-2.45-2.43v-5.97L26.1 6.08h-2.81l5.45 20.33c-.72.88-1.09 2.05-.94 3.23l-5.15 2.97-7.62 12.97 1.41 2.44 11.81-11.8L25.42 58h13.17l-3.45-25.35 4.59 2.65 15.04.12 1.41-2.44-20.21-5.41Zm-4.55-.63c1.2-.32 2.44.39 2.76 1.59a2.246 2.246 0 0 1-1.59 2.75c-1.19.32-2.41-.38-2.74-1.55 0-.01-.01-.03-.01-.04-.33-1.2.39-2.44 1.58-2.75ZM29.97 54l1.96-15.21L34 54h-4.03Z"
      }
    )
  }
);
export {
  n as WindEnergy
};
